import { render, staticRenderFns } from "./VFormItemOpenAndCloseTime.vue?vue&type=template&id=547b6736&"
import script from "./VFormItemOpenAndCloseTime.vue?vue&type=script&lang=js&"
export * from "./VFormItemOpenAndCloseTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('547b6736')) {
      api.createRecord('547b6736', component.options)
    } else {
      api.reload('547b6736', component.options)
    }
    module.hot.accept("./VFormItemOpenAndCloseTime.vue?vue&type=template&id=547b6736&", function () {
      api.rerender('547b6736', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VFormItemOpenAndCloseTime.vue"
export default component.exports